import React from "react";
import { capitalizeFirstLetter } from "../utils";
import { Badge } from "@mantine/core";
import { TaskDto, TaskState, TaskType } from "../dto/user";
import moment from "moment";

const DayCellTitle = ({
  day,
  formattedToday,
  isMemberCalendar,
  tasks = [],
}: {
  day: moment.Moment;
  formattedToday: string;
  isMemberCalendar?: boolean;
  tasks?: TaskDto[];
}) => {
  // Filtrer les tâches "meeting" (vert) et "recordingWriting" (bleu)
  const relevantTasks = tasks.filter(
    (task) =>
      task.type === TaskType.meeting || task.type === TaskType.recordingWriting
  );

  // Statuts considérés comme "prêts" (readyToStart ou plus avancé)
  const readyStates: (TaskState | undefined)[] = [
    TaskState.readyToStart,
    TaskState.validatedByRedactor,
    TaskState.delivered,
    TaskState.billed,
  ];

  // Calculer si toutes les tâches pertinentes sont "prêtes"
  const hasRelevantTasks = relevantTasks.length > 0;
  const allReady =
    hasRelevantTasks &&
    relevantTasks.every((task) => task.state && readyStates.includes(task.state));

  // Afficher l'indicateur tous les jours où il y a des tâches pertinentes
  const showIndicator = hasRelevantTasks;
  return (
    <div
      style={{
        position: "relative",
        width: isMemberCalendar ? 200 : 100,
        height: isMemberCalendar ? undefined : 200,
        textAlign: "center",
        borderBottom: isMemberCalendar ? "1px solid #EAECF0" : undefined,
        borderRight: isMemberCalendar ? "1px solid #EAECF0" : undefined,
        borderLeft: isMemberCalendar ? undefined : "1px solid #EAECF0",
        justifyContent: "center",
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        gap: 10,
        padding: isMemberCalendar ? 10 : undefined,
        flexShrink: isMemberCalendar ? undefined : 0,
      }}
    >
      {/* Indicateur de statut pour le lendemain : vert si tous prêts, rouge sinon (caché pour les membres) */}
      {showIndicator && !isMemberCalendar && (
        <div
          style={{
            position: "absolute",
            top: 8,
            right: 8,
            width: 10,
            height: 10,
            borderRadius: "50%",
            backgroundColor: allReady ? "#60B286" : "#E53935",
          }}
          title={
            allReady
              ? "Tous les dossiers sont prêts à démarrer"
              : "Certains dossiers ne sont pas prêts"
          }
        />
      )}
      <div>{capitalizeFirstLetter(day.format("ddd"))}</div>
      <div>
        {day.format("YYYY-MM-DD") === formattedToday ? (
          <Badge
            style={{
              color: "white",
              height: 48,
              width: 48,
              fontSize: 18,
              overflow: "hidden",
            }}
          >
            {day.format("DD")}
          </Badge>
        ) : (
          <div style={{ height: 48, width: 48, fontSize: 24 }}>
            {day.format("DD")}
          </div>
        )}
      </div>
    </div>
  );
};

export default DayCellTitle;
